import { useEffect } from 'react';
import { useI18nStore } from '@store/i18n';

interface I18nProviderProps {
    children: React.ReactNode;
}

/**
 * Provider to initialize the internationalization system.
 * Loads translations on mount and handles language persistence.
 */
export const I18nProvider: React.FC<I18nProviderProps> = ({
    children,
}): React.ReactElement => {
    const { loadTranslations } = useI18nStore();

    useEffect((): void => {
        loadTranslations();
    }, [loadTranslations]);

    return <>{children}</>;
};
